// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__4Aq_4","errorLogs":"EditorFooter_errorLogs__3_zwj"};